module.exports = __webpack_public_path__ + "img/douyin_qr.c1629b39.png";